export default __webpack_public_path__ + "static/media/switch-on.e5effb7d.svg";